import BASE_URL from "../../config/api";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ImageSkeleton from "../Houses/ImageSkeleton";
import axios from "axios";

function FeaturedPlans() {
  const [loading, setLoading] = useState(false);
  const [drawings, setDrawings] = useState([]);

  const runOnStart = async () => {
    setLoading(true);
    await axios
      .get(`${BASE_URL}/drawing/get-drawings`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("userToken")}` },
      })
      .then((response) => setDrawings([...response.data.data]))
      .catch(() => {});
    setLoading(false);
  };

  useEffect(() => {
    runOnStart();
  }, []);

  return (
    <section className="pt-8 md:pt-10 pb-16 md:pb-20 font-Montserrat">
      <div className="max-w-6xl mx-auto px-4 md:px-10">
        {/* Section header */}
        <div className="text-center mb-12">
          <p className="text-[#1877F2] uppercase tracking-[0.3em] text-xs md:text-sm font-semibold mb-3">
            Our Work
          </p>
          <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mb-4">
            Featured House Plans
          </h2>
          <p className="text-gray-500 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
            Browse a selection of our most popular architectural designs —
            available for purchase and ready to build.
          </p>
        </div>

        {/* Grid */}
        {loading ? (
          <ImageSkeleton />
        ) : drawings.length > 0 ? (
          <>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-6">
              {drawings.slice(0, 6).map((drawing, index) => (
                <div
                  key={index}
                  className="rounded-xl overflow-hidden border border-gray-100 shadow-sm hover:shadow-md transition-all duration-300 group bg-white flex flex-col"
                >
                  <div className="overflow-hidden h-36 md:h-60">
                    <img
                      className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                      src={drawing.frontElevation}
                      alt={drawing.description || "House plan"}
                    />
                  </div>
                  <div className="p-3 md:p-4 flex flex-col flex-1 justify-between">
                    <div>
                      <p className="uppercase text-[10px] md:text-xs font-semibold text-[#1877F2] mb-1">
                        {drawing.refNo}
                      </p>
                      <p className="text-gray-800 text-xs md:text-sm font-medium line-clamp-2 leading-snug">
                        {drawing.description}
                      </p>
                    </div>
                    <Link to={`/house-details/${drawing?._id}`} className="mt-3">
                      <button className="w-full py-1.5 md:py-2 rounded-full border border-[#1877F2] text-[#1877F2] text-[10px] md:text-sm font-semibold hover:bg-[#1877F2] hover:text-white transition-colors duration-200">
                        View Plan
                      </button>
                    </Link>
                  </div>
                </div>
              ))}
            </div>

            {/* CTA */}
            <div className="flex justify-center mt-12">
              <Link
                to="/featured-house-plans"
                className="inline-block bg-[#1877F2] hover:bg-[#0e5fc7] text-white font-semibold py-3 px-10 rounded-full transition-colors duration-200 text-sm md:text-base"
              >
                View All Plans
              </Link>
            </div>
          </>
        ) : (
          <p className="text-center text-gray-400 text-lg py-16">
            No plans available at the moment.
          </p>
        )}
      </div>
    </section>
  );
}

export default FeaturedPlans;
